export default __webpack_public_path__ + "static/media/totalProducts.5624ffb4.png";